module.exports = function isLoggedIn(viewer) {
    if (! viewer) return false
    if (! viewer.user_name) return false
    return true
}
